import { MainThemeVariants } from 'src/types'
import { useThemeContext } from 'src/contexts'
import { COLOR_DICTIONARY } from 'src/constants'

export const useGetColorThemeAndNext = () => {
  const { colorTheme, isDark } = useThemeContext()

  const themeKeys = Object.keys(COLOR_DICTIONARY) as MainThemeVariants[]
  const currentIndex = themeKeys.indexOf(colorTheme)
  const nextIndex = (currentIndex + 1) % themeKeys.length
  const nextTheme = themeKeys[nextIndex]

  const getSafeColor = (value: MainThemeVariants): string => {
    const color = COLOR_DICTIONARY[value]

    return color === COLOR_DICTIONARY[MainThemeVariants.DEFAULT]
      ? isDark
        ? 'white'
        : 'black'
      : color
  }

  return {
    mainThemeColor: getSafeColor(colorTheme),
    nextThemeColor: getSafeColor(nextTheme),
    colorTheme,
  }
}
